<template>
    <div id="aquis">
        <h1 style="display:none;">
            getDonneeResponseADR = {{ getDonneeResponseADR }}
        </h1>
        <p id="title">Acquisition des Droits Intégrée</p>

        <div class="container">
            <div>
                <div class="group">
                    <input type="checkbox" />
                    <label>AMO</label>
                </div>
                <div class="group">
                    <input type="checkbox" />
                    <label>Différences</label>
                </div>
                <div class="group">
                    <button>XML</button>
                </div>
            </div>

            <div style="background: #F4EDFF; padding: 17px;">
                <div class="">
                    <textarea v-model="textAreaContent" style="width:100%;height:500px" readonly></textarea>
                </div>
            </div>
        </div>
    </div>
    
</template>


<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },

        data: function () {
            return {
                message: 'Acquisition des Droits Intégrée',
                textAreaContent: `nom de famille : ADRTROIS
nom usuel : 
prénom : TOUSSAINT
qualite : 0
date de naissance : 01/01/1960
rang de naissance : 1
nir beneficiaire: 160012B020777 cle : 13
nir assure: 160012B020777 cle : 13
signé une déclaration de medecin traitant
regime : 01
caisse gestionnaire : 349
centre gestionnaire : 9881
code gestion : 
situation particulière : aucune
droits du 20/05/2022 au 19/05/2023
couverture : 
jusqu'au 19/05/2022:
	ald : Non | situation : 0100
du 20/05/2022 au 20/10/2022:
	ald : Non | situation : 0105
du 21/10/2022 au 25/10/2022:
	ald : Oui | situation : 0105
du 26/10/2022 au 21/11/2022:
	ald : Oui | situation : 0100
du 22/11/2022 au 30/11/2022:
	ald : Non | situation : 0100
du 01/12/2022 au 31/12/2022:
	ald : Oui | situation : 0100
partir du 01/01/2023:
	ald : Non | situation : 0100
organisme AT : 012619880`
            }
        },

        computed: {
            getDonneeResponseADR() {
                //alert("dans AcquisDroitIntegre.vue computed getDonneeResponseADR")
                this.textAreaContent = this.$store.getters["ChoixBenecStore/getDonneeResponseADR"];
                return this.$store.getters["ChoixBenecStore/getDonneeResponseADR"];
            }
        },

        methods: {

        },

        props: ["beneficiaire"],
        mounted() {

        }

        ,
        created() {

        }

    });
</script>

<style scoped>
    body {
        font-family: Montserrat,sans-serif;
    }

    .container {
        display: block;
        background-color: white;
        border: 0.5px solid;
        border-radius: 0 0 7PX 7PX;
        margin: auto;
        height: auto;
        padding-top: 7px;
    }

    #title {
        /*margin: 7px;*/
        background: #004AAD;
        color: white;
        border-radius: 7px 7px 0 0;
        margin: 0;
        font-size: 20px;
        display: flex;
        justify-content: center;
    }

    #separation {
        background: black;
        height: 1px;
    }
    .element-in-container {
        padding: 7px;
        border: 0.5px solid;
    }
    .group {
        display: inline;
        margin-right: 10px;
    }
</style>
